import { COLLECTION } from "shared/strings/firebase";
import { auth, firestore } from "../containers/firebase";
import { firestoreToArray } from "./helpers";
import axios from "axios";
import { TENANTS_STATUSES } from "constants/statuses";
import { sleep } from "containers/utils";

const VITE_CLOUD_FUNCTION_API_URL = import.meta.env.VITE_CLOUD_FUNCTION_API_URL;

export const getCityById = async (id) => {
  return firestore
    .collection(COLLECTION.Cities)
    .doc(id)
    .get()
    .then(doc => doc.data())
}

export const fetchCityLimitSettings = async (cityId) => {
  // const localKey = `city_access/${cityId}`;
  // const localStored = JSON.parse(localStorage.getItem(localKey) ?? '{}');

  // console.log(`localStored : ${JSON.stringify(localStored)}`);
  // if (localStored.data) {
  //   return localStored.data;
  // }

  const settingsCollectionRef = firestore.collection(`cities/${cityId}/settings`);

  const [cityAccessSnap, onboardingAccessSnap, citizenAccessSnap] = await Promise.all([
    settingsCollectionRef.doc("city_access").get(),
    settingsCollectionRef.doc("onboarding_access").get(),
    settingsCollectionRef.doc("citizen_access").get(),
  ]);

  const cityAccessData = cityAccessSnap.data() || {};
  const onboardingAccessData = onboardingAccessSnap.data() || {};
  const citizenAccessData = citizenAccessSnap.data() || {};

  const data = {
    ...onboardingAccessData,
    ...citizenAccessData,
    ...cityAccessData,
  };

  // localStorage.setItem(localKey, JSON.stringify({
  //   data,
  // }));

  return data;
};

export const fetchCitizenLimitSettings = (cityId) => {
  const ref = firestore
    .collection(`cities/${cityId}/settings`)
    .doc("citizen_access");

  return ref.get().then((snap) => snap.data());
};

export const updateCityLimitSettings = (cityId, field, settings) => {
  const collectionPath = `cities/${cityId}/settings`;

  const ref = firestore.collection(collectionPath).doc("city_access");

  let payload = {
    [field]: settings,
  };

  if (field == "pointsPerSession") {
    updateGlobalLimitSettings(settings);
  }

  if (field == "c14_greenpoint_coefficient") {
    updateGlobalCoefficientSettings(settings);
  }

  if (field == "daysBeforeOrdersexpire") {

    payload = {
      "c26_order_expiration": {
        expirationDays: settings.value
      }
    };

  }


  return ref.set(payload, { merge: true });
};

export const updateCitizenLimitSettings = (cityId, field, settings) => {
  const collectionPath = `cities/${cityId}/settings`;

  const ref = firestore.collection(collectionPath).doc("citizen_access");

  const payload = {
    [field]: settings,
  };

  return ref.set(payload, { merge: true });
};

export const fetchCityMailerLiteSettings = (cityId) => {
  const ref = firestore
    .collection(`cities/${cityId}/settings`)
    .doc("mailerlite");

  return ref.get().then((snap) => snap.data());
};

export const updateCityMailerLiteSettings = (cityId, settings) => {
  const collectionPath = `cities/${cityId}/settings`;

  const ref = firestore.collection(collectionPath).doc("mailerlite");

  return ref.set(settings, { merge: true });
};

const updateGlobalLimitSettings = (settings) => {
  const collectionPath = `greenplay_configurations`;
  const ref = firestore
    .collection(collectionPath)
    .doc("greenpoints_constraints");
  const payload = {
    activeTmMaxLimit: settings.value,
    collectiveTmMaxLimit: settings.value,
    otherTmMaxLimit: settings.value,
  };

  return ref.set(payload, { merge: true });
};

const updateGlobalCoefficientSettings = (settings) => {
  const collectionPath = `greenplay_configurations`;
  const ref = firestore
    .collection(collectionPath)
    .doc("greenpoints_constraints");
  const payload = {
    coefficientGreenpoints: settings.value,
  };

  return ref.set(payload, { merge: true });
};

export const fetchCityMailerLiteConnectedUsers = async (cityId) => {
  const snap = await firestore
    .collection(COLLECTION.Users)
    .where("cityId", "==", cityId)
    .orderBy("subscribeToEmail")
    .get();

  return firestoreToArray(snap)
};

export const syncMailerLiteSubscriptions = async (cityId) => {
  return axios
    .post(`${VITE_CLOUD_FUNCTION_API_URL}/syncMailerLiteSubscriptions/`, { cityId })
    .then(async (res) => {
      const lastSyncMailerLiteSubscriptionsTimestamp = Date.now();
      await firestore
        .collection(COLLECTION.Cities)
        .doc(cityId)
        .update({ lastSyncMailerLiteSubscriptionsTimestamp });

      return lastSyncMailerLiteSubscriptionsTimestamp;
    })
    .catch((err) => console.log("problem with querying APi syncMailerLiteSubscriptions", err));
};

export const removeExcludedUsersFromChallenge = (
  challengeId,
  excludeUsers = []
) => {
  if (!challengeId) {
    throw "challengeId is required";
  }

  return fetch(
    `${VITE_CLOUD_FUNCTION_API_URL}/app/v2/exclude-users-from-challenge/${challengeId}`,
    {
      method: "POST",
      body: JSON.stringify({ excludeUsers }),
    }
  ).then(async (response) => {
    if (!response.ok) {
      const res = await response.json();

      throw new Error(res.message);
    }

    return response;
  });
};

const CITY_TENANT_STORE_FIELDS = [
  "cityId",
  "name",
  "tenantName",
  "firstName",
  "first_name",
  "lastName",
  "last_name",
  "street",
  "city",
  "logoUrl",
  "merchantId",
  "status",
  "orderCount",
  "productCount",
  "customerCount",
];

const pickTenantStoreFields = (tenant = {}) => {
  const picked = { id: tenant.id };
  CITY_TENANT_STORE_FIELDS.forEach((field) => {
    if (tenant[field] !== undefined) {
      picked[field] = tenant[field];
    }
  });
  return picked;
};

export const getCityTenantStores = async (cityId) => {
  // Note: Firestore Web client SDK does not support Query.select() (Admin SDK only).
  // We still fetch matching docs, then keep only the fields used by the UI.
  const tenants = await firestore
    .collection(COLLECTION.Tenants)
    .where("cityId", "==", cityId)
    .get()
    .then(firestoreToArray)
    .then((data) =>
      data.map((tenant) => ({
        status: TENANTS_STATUSES.confirmed,
        ...pickTenantStoreFields(tenant),
      }))
    );

  return tenants;
};

export const getCityCarpoolStats = async ({ ownerId, period, periodKey }) => {
  return axios
    .get(
      `${VITE_CLOUD_FUNCTION_API_URL}/carpoolApi/get-stats-by?ownerId=${ownerId}&period=${period}&periodKey=${periodKey}`
    )
    .then((res) => res.data)
    .catch((err) => console.log("problem with querying APi getCityCarpoolStats", err));
};

export const getCityRawSessionsData = async ({ period, periodKey }) => {
  console.log(`sessionsStatsApi`);
  return axios
    .get(
      `${VITE_CLOUD_FUNCTION_API_URL}/sessionsStatsApi/get-raw-sessions-by?period=${period}&periodKey=${periodKey}&useAlternate=${true}`
    )
    .then((res) => res.data)
    .catch((err) => console.log("problem with querying APi getCityRawSessionsData ", err));
};

export const getCitySessionsData = async ({
  period,
  periodKey,
  distanceMin,
  distanceMax,
  activityType,
}) => {

  const result = await
    axios
      .get(
        `${VITE_CLOUD_FUNCTION_API_URL}/sessionsStatsApi/get-sessions-by?period=${period}&periodKey=${periodKey}&distanceMin=${distanceMin}&distanceMax=${distanceMax}&activityType=${activityType}`
      )
      .then((res) => res.data)
      .catch((err) => console.log("problem with querying APi getCitySessionsData", err));

  console.log(`result : ${JSON.stringify(result)}`);
  return result;
};

export const fetchDashboardOrganisations = async ({
  ownerType,
  ownerId,
  challengeId,
  startDate,
  endDate,
  branchId,
  page = 1,
  limit = 10,
  sortBy = "",
  sortOrder = "asc",
  organisationId,
}) => {
  const queryParams = new URLSearchParams({
    ownerType: ownerType ?? "",
    ownerId: ownerId ?? "",
    branchId: branchId ?? "",
    startDate: startDate ?? "",
    endDate: endDate ?? "",
    challenge: challengeId ?? "",
    page: String(page),
    limit: String(limit),
    sortBy: sortBy ?? "",
    sortOrder: sortOrder ?? "asc",
  });

  if (organisationId) {
    queryParams.set("organisationId", organisationId);
  }

  const res = await axios
    .get(`${VITE_CLOUD_FUNCTION_API_URL}/statsApi/get-total-organisations?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      const status = err?.response?.status;
      console.log(`error get-total-organisations : ${err}`);
      if (status) {
        throw new Error(`get-total-organisations failed (${status})`);
      }
      throw err;
    });

  return res;
};


export const fetchCityDashboardOrganisationsForExport = async ({ ownerType, ownerId, challengeId, startDate, endDate, branchId, region, geographicalAgrerationLevel, transportModes = [] }) => {
  const normalizedTransportModes = Array.isArray(transportModes) ? transportModes.join(",") : (transportModes ?? "");
  const res = await axios
    .get(
      `${VITE_CLOUD_FUNCTION_API_URL}/statsApi/get-total-organisations-with-activities?ownerType=${ownerType}&ownerId=${ownerId}&branchId=${branchId}&startDate=${startDate}&endDate=${endDate}&challenge=${challengeId}&region=${region ?? ""}&geographicalAgrerationLevel=${geographicalAgrerationLevel ?? ""}&transportModes=${normalizedTransportModes}`
    )
    .then((res) => res.data)
    .catch((err) => { console.log(`error get-total-organisations-with-activities : ${err}`) });


  return res;
};


export const fetchCitySessionTracks = async ({
  startDate,
  endDate,
  startTime,
  endTime,
  cityId,
  organisationId,
  userId,
  tolerance,
}) => {
  if (!startDate || !endDate || startTime === undefined || endTime === undefined) {
    throw new Error("Missing required heat map parameters.");
  }

  if (!cityId && !organisationId) {
    throw new Error("cityId or organisationId is required.");
  }

  if (!auth.currentUser) {
    throw new Error("User must be authenticated.");
  }

  const token = await auth.currentUser.getIdToken();
  const payload = {
    startDate,
    endDate,
    startTime,
    endTime,
    ...(cityId ? { cityId } : {}),
    ...(organisationId ? { organisationId } : {}),
    ...(userId ? { userId } : {}),
    ...(tolerance !== undefined ? { tolerance } : {}),
  };

  let res;

  try {
    const response = await axios.post(
      `${VITE_CLOUD_FUNCTION_API_URL}/getSessionsTracks`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    res = response.data;
  } catch (error) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch sessions tracks.";

    const normalizedError = new Error(message);
    normalizedError.status = status;
    throw normalizedError;
  }

  const normalizedResult = Array.isArray(res) ? res : [];

  const items = normalizedResult.filter((i) => i.activityType != null);
  const activityTypes = items.map((item) => item.activityType);

  const features = items.map((item) => {
    const geog = item.geometry;
    const parsed = JSON.parse(geog);

    return {
      type: "Feature",
      properties: {
        ...item,
      },
      geometry: parsed,
    };
  });
  const featureCol = {
    type: "FeatureCollection",
    features,
  };
  const newActivityTypes = [...new Set(activityTypes)];

  return {
    items,
    geojson: featureCol,
    newActivityTypes,
  };
};

export const getCarpoolingRequestsTracks = async ({
  startDate,
  endDate,
  startTime,
  endTime,
  cityId,
  organisationId,
  userId,
  tolerance,
}) => {
  if (!startDate || !endDate || startTime === undefined || endTime === undefined) {
    throw new Error("Missing required heat map parameters.");
  }

  if (!cityId && !organisationId) {
    throw new Error("cityId or organisationId is required.");
  }

  if (!auth.currentUser) {
    throw new Error("User must be authenticated.");
  }

  const token = await auth.currentUser.getIdToken();

  const payload = {
    startDate,
    endDate,
    startTime,
    endTime,
    ...(cityId ? { cityId } : {}),
    ...(organisationId ? { organisationId } : {}),
    ...(userId ? { userId } : {}),
    ...(tolerance !== undefined ? { tolerance } : {}),
  };

  let res;

  try {
    const response = await axios.post(
      `${VITE_CLOUD_FUNCTION_API_URL}/getCarpoolingRequestsTracks`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    res = response.data;
  } catch (error) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch carpooling requests tracks.";

    const normalizedError = new Error(message);
    normalizedError.status = status;
    throw normalizedError;
  }

  const normalizedResult = Array.isArray(res) ? res : [];

  const items = normalizedResult;

  const parseWktLineString = (wkt) => {
    if (typeof wkt !== "string") {
      return null;
    }

    const matches = wkt.trim().match(/^LINESTRING\s*\((.*)\)$/i);
    if (!matches?.[1]) {
      return null;
    }

    const coordinates = matches[1]
      .split(",")
      .map((pair) => pair.trim().split(/\s+/).map((value) => Number(value)))
      .filter((pair) => pair.length >= 2 && Number.isFinite(pair[0]) && Number.isFinite(pair[1]))
      .map((pair) => [pair[0], pair[1]]);

    if (coordinates.length < 2) {
      return null;
    }

    return {
      type: "LineString",
      coordinates,
    };
  };

  const normalizeTrackGeometry = (rawGeometry) => {
    if (!rawGeometry) {
      return null;
    }

    if (typeof rawGeometry === "object" && rawGeometry?.type && rawGeometry?.coordinates) {
      return rawGeometry;
    }

    if (typeof rawGeometry === "object" && typeof rawGeometry?.value === "string") {
      return parseWktLineString(rawGeometry.value);
    }

    if (typeof rawGeometry === "string") {
      const trimmed = rawGeometry.trim();

      try {
        const parsedJson = JSON.parse(trimmed);
        if (parsedJson?.type && parsedJson?.coordinates) {
          return parsedJson;
        }
        if (typeof parsedJson?.value === "string") {
          return parseWktLineString(parsedJson.value);
        }
      } catch (error) {
        // fall through to WKT parsing
      }

      return parseWktLineString(trimmed);
    }

    return null;
  };

  const features = items
    .map((item) => {
      const rawGeometry = item?.geometry;
      if (!rawGeometry) {
        return null;
      }

      const parsedGeometry = normalizeTrackGeometry(rawGeometry);

      if (!parsedGeometry) {
        return null;
      }

      return {
        type: "Feature",
        properties: {
          ...item,
          activityType: item?.activityType || "carpool",
        },
        geometry: parsedGeometry,
      };
    })
    .filter(Boolean);

  const featureCol = {
    type: "FeatureCollection",
    features,
  };

  const newActivityTypes = [
    ...new Set(items.map((item) => item?.activityType || "carpool")),
  ];

  return {
    items,
    geojson: featureCol,
    newActivityTypes,
  };
};
